<template>
  <v-alert
    class="mx-3"
    type="error"
    dense
    text
    variant="tonal"
    icon="mdi-alert-circle-outline"
    style="margin-right: 0px !important; margin-left: 0px !important">
    Warning: These features change core behavior of the Graphics Engine and can
    cause severe issues if adjusted from default values. Only adjust if you know
    what you're doing!
  </v-alert>
  <v-checkbox
    v-model="userEditObj.dynamic_preload"
    label="Prioritize Memory Usage"
    append-icon="mdi-feather"
    persistent-hint
    hint="Disables caching which will increase load times and processing to reduce memory usage. Ideal for very heavy templates while using Cue/Take workflows."></v-checkbox>
  <v-checkbox
    v-model="selfSwap"
    label="Self Swap Mode"
    append-icon="mdi-swap-horizontal-bold"
    persistent-hint
    hint="Always re-use the same instance instead of using a new instance during transition to itself. Ideal for using CanvasPro conditions to change the state of the template."></v-checkbox>

  <v-checkbox
    v-model="props.userEditObj.extra_info.cue_take_startup"
    label="Load Cue/Take on Startup"
    append-icon="mdi-one-up"
    persistent-hint
    hint="Load the scene for cue/take on Startup instead of adhoc"></v-checkbox>
  <v-checkbox
    v-if="props.userEditObj.extra_info?.nested_template"
    v-model="props.userEditObj.extra_info.ignore_empty"
    label="Ignore Empty ScenePorts"
    append-icon="mdi-sitemap-outline"
    persistent-hint
    hint="Nested Templates Only:  If a ScenePort has a Scene but the next Scene doesn't have a Scene there, then we keep the current scene, instead of removing it (State Based)"></v-checkbox>
</template>
<script setup>
import { ref, onMounted, watch } from 'vue';
const props = defineProps(['userEditObj']);
const selfSwap = ref(false);
onMounted(() => {
  selfSwap.value = !props.userEditObj.multi;
});
watch(
  () => selfSwap.value,
  (val) => {
    props.userEditObj.multi = !val;
  }
);
</script>
